import { createAsyncThunk } from '@reduxjs/toolkit'
import Configuration from '../../../services/api/Configuration'
import { addToArrIfNotExistOrRemove } from '../../../utils/helpers'
import RestClient from '../../../services/client/RestClient'

const { User_Batch_Action_Details_Endpoints } = Configuration

export const userBatchStatusDetailsResetAlertHandler = createAsyncThunk(
  'userBatchStatusDetails/userBatchStatusDetailsResetAlertHandler',
  async () => ({}),
)

export const retrieveBatchStatusDetailsByID = createAsyncThunk(
  'userBatchStatusDetails/retrieveBatchStatusDetailsByID',
  async ({ queries }, { rejectWithValue }) => {
    const api = User_Batch_Action_Details_Endpoints(queries)
    const response = await RestClient.getRequest(`${api.getStatusDetailsId}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response
  },
)

function createReqHelper(store, { key, value }) {
  const copyStore = { ...store }
  if (key) {
    copyStore[key] = value
  }
  const getFilterIds = (filters) => (filters || []).map((filter) => filter.id)
  const filterStatusIds = getFilterIds(copyStore?.activeFilters)?.join('&status_ids=')

  const {
    activeSearch,
    pageSize,
    activeSort,
    pageNumber,
  } = copyStore

  const response = [
    `search=${activeSearch}`,
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize}`,
    `sort_by=${activeSort?.key || ''}`,
    `status_ids=${filterStatusIds}`,
  ].join('&')
  return response
}
export const retrieveStatusDetailsEmployeesByID = createAsyncThunk(
  'userBatchStatusDetails/retrieveStatusDetailsEmployeesByID',
  async ({ queries }, { getState, rejectWithValue }) => {
    const api = User_Batch_Action_Details_Endpoints(queries)
    const { userBatchStatusDetails } = getState()
    const filters = createReqHelper(userBatchStatusDetails, {})
    const response = await RestClient.getRequest(`${api.getStatusDetailsIdUser}?${filters}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return { response: response.data, batchId: queries }
  },
)

export const filterStatusDetailsEmployeesList = createAsyncThunk(
  'userBatchStatusDetails/filterStatusDetailsEmployeesList',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { userBatchStatusDetails } = getState()
    const api = User_Batch_Action_Details_Endpoints(userBatchStatusDetails.batchId)
    let newFilterArr

    if (queries === 'clear') {
      newFilterArr = []
    } else if (Array.isArray(queries)) {
      newFilterArr = queries
    } else {
      newFilterArr = addToArrIfNotExistOrRemove(userBatchStatusDetails.activeFilters, 'id', queries)
    }

    const filters = createReqHelper(userBatchStatusDetails, { key: 'activeFilters', value: newFilterArr })
    const response = await RestClient.getRequest(`${api.getStatusDetailsIdUser}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return { response: response.data, filter: newFilterArr }
  },
)

export const sortStatusDetailsEmployeesList = createAsyncThunk(
  'userBatchStatusDetails/sortStatusDetailsEmployeesList',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { userBatchStatusDetails } = getState()
    const api = User_Batch_Action_Details_Endpoints(userBatchStatusDetails.batchId)
    const filters = createReqHelper(userBatchStatusDetails, { key: 'activeSort', value: { key: queries?.key } })
    const response = await RestClient.getRequest(`${api.getStatusDetailsIdUser}?${filters}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return { response: response.data, sort: queries }
  },
)

export const searchStatusDetailsEmployeesList = createAsyncThunk(
  'userBatchStatusDetails/searchStatusDetailsEmployeesList',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { userBatchStatusDetails } = getState()
    const api = User_Batch_Action_Details_Endpoints(userBatchStatusDetails.batchId)
    const filters = createReqHelper(userBatchStatusDetails, { key: 'activeSearch', value: queries || '' })
    const response = await RestClient.getRequest(`${api.getStatusDetailsIdUser}?${filters}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return {
      response: response.data,
      search: queries || '',
    }
  },
)
export const statusDetailsEmployeesListPagination = createAsyncThunk(
  'userBatchStatusDetails/statusDetailsEmployeesListPagination',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { userBatchStatusDetails } = getState()
    const api = User_Batch_Action_Details_Endpoints(userBatchStatusDetails.batchId)
    const filters = createReqHelper(userBatchStatusDetails, { key: 'pageNumber', value: queries })
    const response = await RestClient.getRequest(`${api.getStatusDetailsIdUser}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      pageNumber: queries,
    }
  },
)
